import { IFeed } from '@ninjacart/nc-nk-core';
import {
  addEventParam,
  INinjaEvent,
  useQueuedEventStore
} from '@ninjacart/nc-events-sdk-v2';
import { useFeedStore } from '../../store/useFeedStore';
import paths from '../paths';
import { KisaanClient } from './axiosKisaanClient';
import { KissanEventType } from '../../utils/eventConstants';


export const getHomeFeed = async (
  payload,
  cropIdParams: string[] = [],
  cropNameParams: string[] = [],
): Promise<IFeed> => {
  const enqueue = useQueuedEventStore.getState()?.enqueue;
  try {
    if (cropIdParams?.length) {
      payload.preferenceId = cropIdParams;
    }
    if (cropNameParams?.length) {
      payload.preferenceName = cropNameParams;
    }
    const response = await KisaanClient.post<IFeed>(paths.getHomePageFeedPath(), payload);
    useFeedStore.getState()?.setHomeFeedsCard(response?.data?.data);
    return response?.data;
  } catch (error) {
    if (error?.code === 'ERR_NETWORK') {
      const AdditionalDetail = [
        addEventParam('count', payload?.count),
        addEventParam('offset', payload?.offset),
        addEventParam('referenceKey5', 'refresh'),
        addEventParam('referenceValue5', payload?.refresh),
        addEventParam('userPreferenceId', payload?.userPreferenceId),
        addEventParam('hasLogin', payload?.hasLogin),
      ];
      const homeFeedTimeOutEvent: INinjaEvent = {
        name: KissanEventType.HOMEFEED_TIMEOUT,
        screenDetails: { screen: 'feed page' },
        eventParams: AdditionalDetail,
      };
      enqueue(homeFeedTimeOutEvent);
      console.log('Falling back on network err with cached data!!!');
      const cacheFeed: IFeed = {
        count: 0,
        data: useFeedStore.getState()?.homeFeedsCard ?? [],
        message: '',
        next: '',
        offset: 0,
        statusCode: 200,
      };

      return cacheFeed;
    }

    throw error;
  }
};